module.exports = require('./helpers/bundle-url').getBundleURL('aMO4G') + "logo.c51670a8.svg";